import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export type getAvailableReceivablesListDataType = {
  id: string;
  successCallback?: Function;
  errorCallback?: Function;
  resultKey?: string;
};

export default ({
  id,
  successCallback,
  errorCallback,
  resultKey = 'availableReceivablesList',
}: getAvailableReceivablesListDataType) =>
  requestAsync({
    url: endpoints.getEditAvailableReceivablesListUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: `${endpoints.getEditAvailableReceivablesListUrl(id)}`,
    options: {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
